export const DAYS_OF_WEEK = [
  { value: '0', label: 'Sun', shortLabel: 'S' },
  { value: '1', label: 'Mon', shortLabel: 'M' },
  { value: '2', label: 'Tue', shortLabel: 'T' },
  { value: '3', label: 'Wed', shortLabel: 'W' },
  { value: '4', label: 'Thu', shortLabel: 'T' },
  { value: '5', label: 'Fri', shortLabel: 'F' },
  { value: '6', label: 'Sat', shortLabel: 'S' },
] as const;
